import { useQuery } from "@tanstack/react-query";
import { getSupplier } from "../../api/apiSuppliers";
import i18next from "i18next";

const useGetSupplier = (id) => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["supplier", id, i18next.language],
        queryFn: () => getSupplier(id),
        enabled: !!id,
    });

    return {
        supplier: data?.data || null,
        error,
        isLoading,
    };
};

export default useGetSupplier;
